import React, { useMemo } from 'react';
import { useSiteContext } from '../../context/site-content.context';

interface Props {
    source: string | string[];
    className?: string;
}

// ToDo: I need to be super-specific about what I allow and what I disallow using the DOMpurifier
// https://www.npmjs.com/package/dompurify
export const ContentHtml = ({ source, className }: Props): React.ReactElement<any, any> | null => {
    const {
        config: { sanitizeHtml },
    } = useSiteContext();

    const html = useMemo(() => {
        const sourceStr = Array.isArray(source) ? source.join('') : source;
        return sanitizeHtml ? sanitizeHtml(sourceStr) : sourceStr;
    }, [sanitizeHtml, source]);

    return (
        <div
            className={`content-body ${className ? className : ''}`}
            dangerouslySetInnerHTML={{
                __html: html,
            }}
        ></div>
    );
};

/*

<div
    className={`content-body ${className ? className : ''}`}
    dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(sourceStr, {
            USE_PROFILES: { html: true },
            ADD_ATTR: ['target'],
        }),
    }}
></div>

*/
